import Swal from "sweetalert2";

const ChangeUserPassword = (
  userName,
  passUser,
  onlineResetUserPassword,
  setChangePasswordStatus,
  setNewUserPassword
) => {
  const requirementsMessage = `
    <div class="swalValidationMsg" id="swal2-validation-message" style='text-Align: left; font-size: 14px' >            
            <li>At least 8 characters</li>
            <span style="font-weight: bold">At least 2 of the following:</span>
             <li>At least 1 uppercase letter</li>
              <li>At least 1 lowercase letter</li>
             <li>At least 1 number</li>
              <li>At least 1 special character (@$!%*?&amp;)</li>          
    </div>
`;

  const calculatePasswordStrength = (password) => {
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[@$!%*?&]/.test(password);

    if (
      (password.length >= 8 && hasUppercase) ||
      (password.length >= 8 && hasLowercase) ||
      (password.length >= 8 && hasNumber) ||
      (password.length >= 8 && hasSpecialChar)
    ) {
      return "Strong";
    } else if (
      (password.length >= 3 && password.length <= 7 && hasUppercase) ||
      (password.length >= 3 && password.length <= 7 && hasLowercase) ||
      (password.length >= 3 && password.length <= 7 && hasNumber) ||
      (password.length >= 3 && password.length <= 7 && hasSpecialChar)
    ) {
      return "Moderate";
    } else if (password.length >= 1 && password.length <= 2) {
      return "Weak";
    } else {
      return "";
    }
  };

  const calculateStrengthPercentage = (strength) => {
    switch (strength) {
      case "Strong":
        return 100;
      case "Moderate":
        return 75;
      case "Weak":
        return 50;
      case "Very Weak":
        return 25;
      default:
        return 0;
    }
  };

  const calculateStrengthColor = (strength) => {
    switch (strength) {
      case "Weak":
        return "bg-danger";
      case "Moderate":
        return "bg-warning";
      case "Strong":
        return "bg-success";
      default:
        return "";
    }
  };

  const validatePassword = (password) => {
    const hasLength = password.length >= 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[@$!%*?&]/.test(password);

    const validationsMet = [
      hasUppercase,
      hasLowercase,
      hasNumber,
      hasSpecialChar,
    ].filter(Boolean).length;

    if (hasLength && validationsMet >= 2) {
      return "Valid";
    } else {
      return `Your password does not meet the requested requirements.`;
    }
  };

  const resetOnlinePassword = async (password) => {
    let res = await onlineResetUserPassword({
      LoginName: userName,
      OldPassword: passUser,
      NewPassword: password,
    });

    return res;
  };

  return Swal.fire({
    title:
      "<span>" +
      userName +
      "</span>" +
      "<br/>" +
      "<span style='font-size: 16px;'>Your password has expired. Would you like to change it now?</span>" +
      "<p style='font-size: 12px; color: red'>If you do not change your password, you will not be allowed to log in.</p>",
    focusConfirm: false,
    html:
      `
      <div class="input-group mt-2" style="background: none;" >
      <input class="form-control" id="currentPassword" type="password" value="${passUser}" disabled placeholder="Enter your current password" style="margin-right: 0px;"/>
      <div className="input-group-append"> <span id="toggleCurrentPassword" class="input-group-text" >
        <i id="viewCurrentPass" class="fa fa-eye" aria-hidden="true"></i>
      </span> </div>
    </div>
    <div class="input-group mt-2" style="background: none;" >
      <input class="form-control" id="newPassword" type="password" placeholder="Enter your new password" style="margin-right: 0px;"/>
      <div className="input-group-append"> <span id="togglePassword" class="input-group-text" >
        <i id="viewPass" class="fa fa-eye" aria-hidden="true"></i>
      </span> </div>
    </div>
    <div class="input-group mt-2" style="background: none;" >
    <input class="form-control" id="retypePassword" type="password" placeholder="Retype your new password" style="margin-right: 0px;"/>
    <div className="input-group-append"> <span id="togglePassword2" class="input-group-text" >
      <i id="viewPass2" class="fa fa-eye" aria-hidden="true"></i>
    </span> </div>
  </div>    
    <div id="passwordStrength" class="mt-1" style="font-size: 12px;">     
      <div class="progress mt-1">
        <div id="strengthBar" class="progress-bar" role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <span id="strengthText"></span>
    </div>

  ` + requirementsMessage,
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "grey",
    confirmButtonText: "Update",
    confirmButtonColor: "green",
    allowOutsideClick: false,

    didOpen: () => {
      const newPasswordInput = document.getElementById("newPassword");
      const retypePasswordInput = document.getElementById("retypePassword");
      const currentPasswordInput = document.getElementById("currentPassword");
      const togglePassword = document.getElementById("togglePassword");
      const togglePassword2 = document.getElementById("togglePassword2");
      const toggleCurrentPassword = document.getElementById(
        "toggleCurrentPassword"
      );
      const strengthText = document.getElementById("strengthText");
      const strengthBar = document.getElementById("strengthBar");
      const viewPassword = document.getElementById("viewPass");
      const viewPassword2 = document.getElementById("viewPass2");
      const viewCurrentPass = document.getElementById("viewCurrentPass");

      togglePassword.addEventListener("click", () => {
        if (newPasswordInput.type === "password") {
          newPasswordInput.type = "text";
          viewPassword.className = "fas fa-eye-slash";
        } else {
          newPasswordInput.type = "password";
          viewPassword.className = "fas fa-eye";
        }
      });

      togglePassword2.addEventListener("click", () => {
        if (retypePasswordInput.type === "password") {
          retypePasswordInput.type = "text";
          viewPassword2.className = "fas fa-eye-slash";
        } else {
          retypePasswordInput.type = "password";
          viewPassword2.className = "fas fa-eye";
        }
      });

      toggleCurrentPassword.addEventListener("click", () => {
        if (currentPasswordInput.type === "password") {
          currentPasswordInput.type = "text";
          viewCurrentPass.className = "fas fa-eye-slash";
        } else {
          currentPasswordInput.type = "password";
          viewCurrentPass.className = "fas fa-eye";
        }
      });

      newPasswordInput.addEventListener("input", (event) => {
        const password = event.target.value;
        const strength = calculatePasswordStrength(password);

        strengthText.textContent = `${strength}`;
        strengthBar.style.width = `${calculateStrengthPercentage(strength)}%`;
        strengthBar.className = `progress-bar ${calculateStrengthColor(
          strength
        )}`;
      });
    },
    preConfirm: async () => {
      const newPassword = document.getElementById("newPassword").value;
      const retypePassword = document.getElementById("retypePassword").value;

      const validationMessage = validatePassword(newPassword);
      if (validationMessage === "Valid") {
        if (!retypePassword) {
          Swal.showValidationMessage("Retype password field is required");
          return false;
        } else if (newPassword !== retypePassword) {
          Swal.showValidationMessage("Passwords do not match");
          return false;
        } else {
          const res = await resetOnlinePassword(newPassword);
          if (!res.error) {
            setNewUserPassword({ user: userName, password: newPassword });
            setChangePasswordStatus(true);
            return true;
          } else {
            Swal.showValidationMessage(res.error);
            return false;
          }
        }
      } else {
        Swal.showValidationMessage(validationMessage);
        return false;
      }
    },
  });
};

export default ChangeUserPassword;
